import { useProject } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useProject';

export const useIsRestorationProject = () => {
  const project = useProject();
  return project?.subtype === 'restoration';
};
